import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'bepatient-loading-measures-error-popup',
  templateUrl: './loading-measures-error-popup.component.html',
  styleUrls: ['./loading-measures-error-popup.component.scss'],
  standalone: false
})
export class LoadingMeasuresErrorPopupComponent {
  @Input() color: string;
  @Input() message: string;
  @Input() buttonLabel: string;
  @Output() validated = new EventEmitter<boolean>();
}
